import React from 'react';
       

export default class Card extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({isLoading: false})
        }, 2000);
    }
    
    render(){
        return (
            <div className="container">
                <div className="cardimg">
                    <img src={this.props.image} alt={this.props.detail} width='200px' className="image"/>
                </div>
                <div className="overlay">
                    <div className="text">
                        {this.props.detail}
                    </div>
                </div>
            </div>
        );
    }
}
